import { ServerComProtocol } from './server-com-protocol';
import { VirtualServerConfigResolved } from './virtual-tap';
import { VirtualTap } from './virtual-tap-server';

export type CreateServerComProtocolFromConfigFct = (
  protocolConfig: VirtualServerConfigResolved['protocols'][number],
  config: VirtualServerConfigResolved
) => ServerComProtocol | undefined;

export function createVirtualTap(
  config: VirtualServerConfigResolved,
  protocolFactory: CreateServerComProtocolFromConfigFct
) {
  const virtualTap = VirtualTap.create(config.device, config.config);

  for (const protocolConfig of config.protocols) {
    const protocolInstance = protocolFactory(protocolConfig, config);
    if (!protocolInstance) {
      throw new Error(`No protocol factory for: ${protocolConfig.type}`);
    }
    virtualTap.registerHostProtocol(protocolInstance);
  }

  if (config.target) {
    virtualTap.setTarget(config.target);
  }

  return virtualTap;
}
